













































































































































import CtrlDatePicker from '@/components/common/control/CtrlDatePicker.vue';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import CtrlNormalTxt from '@/components/common/control/CtrlNormalTxt.vue';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlHimmoku from '@/components/common/search/CtrlHimmoku.vue';
import { OutStatus, ShoriKb, TaishoFlg, UmuFlg } from '@/constants/constants';
import { BUTTON } from '@/constants/label';
import {
  calcAmount,
  calcWeight,
  convertStr2Num,
  dateStrToNum,
  isShorikbADD,
  isShorikbREFER,
  isShorikbUPD,
} from '@/utils/utils';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend<any, any, any, any>({
  name: 'G_080_KojoDekidakaEntry_ChildHeaderInput',
  components: {
    CtrlNormalBtn,
    CtrlMessageDialog,
    CtrlHimmoku,
    CtrlNormalTxt,
    CtrlNumTxt,
    CtrlDatePicker,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    shoriKb: {
      type: Number,
      default: ShoriKb.ADD,
    },
    childItem: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    BUTTON,
    UmuFlg,
    TaishoFlg,
    childHeaderInput: {
      kyoryokuKojoCd: 0,
      himmokuCd: 0,
      seizoYmd: 0,
      dekidakaSuryo: 0,
      shomiKigenYmd: 0,
    },
    himmokuItem: null,
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    cMessageShow1: false,
    cMessageId1: '',
    cMessageTextParam1: [],
    messageConfirmSubmit: false,
    isReload: false,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
      childHeaderTitle: 'common/childHeaderTitle',
    }),
    isAdd() {
      return isShorikbADD(this.shoriKb);
    },
    isUpd() {
      return isShorikbUPD(this.shoriKb);
    },
    isRef() {
      return isShorikbREFER(this.shoriKb);
    },
    tani() {
      return this.himmokuItem ? this.himmokuItem.tani : '';
    },
    irisu() {
      return this.himmokuItem ? this.himmokuItem.irisu : 0;
    },
    juryo() {
      if (this.himmokuItem) {
        return calcWeight(
          this.himmokuItem.caseWeight,
          this.childHeaderInput.dekidakaSuryo,
          0,
          this.irisu
        );
      }
      return 0;
    },
  },
  methods: {
    hide(reload = true) {
      this.$emit('update:show', false);
      this.$emit('hide', reload);
    },
    callbackOkHimmoku(item: any) {
      if (item && item.himmokuCd) {
        this.childHeaderInput.himmokuCd = item.himmokuCd;
        this.himmokuItem = item;
      } else {
        this.childHeaderInput.himmokuCd = 0;
        this.himmokuItem = null;
      }
    },
    handleCancelMessage() {
      this.messageConfirmSubmit = false;
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
      if (this.isReload) {
        this.hide();
      }
      if (this.messageConfirmSubmit) {
        this.messageConfirmSubmit = false;
        this.handleSubmit();
      }
    },
    async handleDelete() {
      this.$store.dispatch('common/setIsLoading', true);
      const { kyoryokuKojoCd, himmokuCd, seizoYmd, koshinCount } =
        this.childItem;

      const params = {
        kyoryokuKojoCd,
        himmokuCd,
        seizoYmd: dateStrToNum(seizoYmd),
        jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
        genzaiYmd: this.userInfo.onlineData.genzaiYmd,
        koshinCount,
      };
      const res = await this.$store.dispatch(
        'g080/deleteKojoDekidakaEntryItem',
        params
      );
      this.$store.dispatch('common/setIsLoading', false);
      const { error } = res.data;
      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.messageID &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        if (error.outStatus == OutStatus.CHECK_ERR) {
          this.messageShow = true;
          this.messageId = error.messageID;
          this.messageTextParam = error.messageArgs;
          return;
        } else if (error.outStatus == OutStatus.EXCLUSIVE_ERR) {
          this.messageShow = true;
          this.messageId = error.messageID;
          this.messageTextParam = error.messageArgs;
          this.isReload = true;
          return;
        }
      }
      this.hide();
    },
    async handleSubmit() {
      // ローディング・スタート
      this.$store.dispatch('common/setIsLoading', true);
      const {
        kyoryokuKojoCd,
        himmokuCd,
        seizoYmd,
        dekidakaSuryo,
        shomiKigenYmd,
      } = this.childHeaderInput;

      const requestData = {
        commonInfo: {
          jigyoshoCd: this.userInfo.jigyoshoData.jigyoshoCd,
          genzaiYmd: this.userInfo.onlineData.genzaiYmd,
        },
        kojoDekidakaData: {
          kyoryokuKojoCd,
          himmokuCd,
          seizoYmd: dateStrToNum(seizoYmd),
          dekidakaSuryo: convertStr2Num(dekidakaSuryo),
          shomiKigenYmd: dateStrToNum(shomiKigenYmd),
          // only Upd
          ...(this.isUpd && {
            koshinCount: this.childHeaderInput.koshinCount,
            seizoYmd: dateStrToNum(this.childItem.seizoYmd),
            aftSeizoYmd: dateStrToNum(seizoYmd),
          }),
        },
      } as any;

      const actionName = this.isUpd
        ? 'g080/putKojoDekidakaEntryItem'
        : 'g080/postKojoDekidakaEntry';
      const res = await this.$store.dispatch(actionName, requestData);
      this.$store.dispatch('common/setIsLoading', false);

      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.messageID &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        const { error } = res.data;
        if (error.outStatus == OutStatus.CHECK_ERR) {
          this.messageShow = true;
          this.messageId = error.messageID;
          this.messageTextParam = error.messageArgs;
          return;
        } else if (error.outStatus == OutStatus.EXCLUSIVE_ERR) {
          this.messageShow = true;
          this.messageId = error.messageID;
          this.messageTextParam = error.messageArgs;
          this.isReload = true;
          return;
        }
      }
      this.hide();
    },
    async checkValidate() {
      await new Promise((resolve) => setTimeout(resolve, 300));
      this.$refs.form.validate();
      const childHeaderInput = this.childHeaderInput;

      if (!childHeaderInput.himmokuCd) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['品目'];
        this.messageShow = true;
        return;
      }
      if (!dateStrToNum(childHeaderInput.seizoYmd)) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['製造日'];
        this.messageShow = true;
        return;
      }
      if (!convertStr2Num(childHeaderInput.dekidakaSuryo)) {
        this.messageId = 'KI_W100';
        this.messageTextParam = ['出来高数'];
        this.messageShow = true;
        return;
      }
      if (
        childHeaderInput.shomiKigenYmd &&
        dateStrToNum(childHeaderInput.shomiKigenYmd) <
          dateStrToNum(childHeaderInput.seizoYmd)
      ) {
        this.messageId = 'KI_W109';
        this.messageTextParam = ['賞味期限', '製造日より過去'];
        this.messageShow = true;
        return;
      }
      if (!this.$refs.form.validate()) {
        this.messageId = 'KI_W121';
        this.messageTextParam = [];
        this.messageShow = true;
        return;
      }
      return true;
    },
    async getData() {
      const { kyoryokuKojoCd, himmokuCd, seizoYmd } = this.childItem;

      const params = {
        kyoryokuKojoCd,
        himmokuCd,
        seizoYmd: dateStrToNum(seizoYmd),
      };
      const res = await this.$store.dispatch(
        'g080/getKojoDekidakaEntryItem',
        params
      );
      this.$store.dispatch('common/setIsLoading', false);
      if (
        res &&
        res.status == 200 &&
        res.data &&
        res.data.error &&
        res.data.error.outStatus &&
        res.data.error.outStatus != OutStatus.NORMAL
      ) {
        this.messageId = res.data.error.messageID;
        this.messageTextParam = res.data.error.messageArgs;
        this.messageShow = true;
        this.isReload = true;
        return;
      }

      if (
        this.isUpd &&
        res.data.responseData.koshinCount !== this.childItem.koshinCount
      ) {
        this.messageId = 'KI_W107';
        this.messageTextParam = [];
        this.messageShow = true;
        this.isReload = true;
        return;
      }

      this.childHeaderInput = {
        ...this.childHeaderInput,
        ...res.data.responseData,
      };
    },
    async handleSave() {
      if (await this.checkValidate()) {
        const childHeaderInput = this.childHeaderInput;
        const genzaiYmd = this.userInfo.onlineData.genzaiYmd;

        if (dateStrToNum(childHeaderInput.seizoYmd) > genzaiYmd) {
          this.cMessageShow1 = true;
          this.cMessageId1 = 'KI_Q103';
          this.cMessageTextParam1 = ['製造日が未来日です', '続行して'];
          return;
        }

        if (
          childHeaderInput.shomiKigenYmd &&
          dateStrToNum(childHeaderInput.shomiKigenYmd) < genzaiYmd
        ) {
          this.cMessageShow1 = true;
          this.cMessageId1 = 'KI_Q103';
          this.cMessageTextParam1 = ['賞味期限が過去日です', '続行して'];
          return;
        }
        this.cHandleSubmit1();
      }
    },
    cHandleSubmit1() {
      this.messageConfirmSubmit = true;
      this.messageId = 'KI_Q100';
      this.messageTextParam = [this.isUpd ? '変更' : '追加'];
      this.messageShow = true;
    },
  },
  async created() {
    this.childHeaderInput = {
      ...this.childHeaderInput,
      ...this.childItem,
    };
    this.$store.dispatch('common/getChildHeaderTitle', {
      shoriKb: this.shoriKb,
    });
    this.$store.dispatch('common/setIsLoading', true);

    if (this.isAdd) {
      this.$store.dispatch('common/setIsLoading', false);
    } else {
      await this.getData();
    }
  },
});
